import { CopyIcon } from "@/assets/icons/CopyIcon";
import { cn } from "@/lib/utils";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { StepFooter } from "./stepFooter";
import { useGetAuthenticatedUser } from "@/api/user";
import { generateCircleShareLink } from "@/utils/share";

export const ThankYouStep = ({
  circleId,
  currentStep,
}: {
  circleId: string | null;
  currentStep: number;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: user } = useGetAuthenticatedUser();

  const shareData = {
    url: generateCircleShareLink(circleId, user?.id),
  };

  return (
    <>
      <div className="scrollbar-hide mt-2 flex h-screen w-full flex-col gap-16 overflow-y-auto bg-background pt-14 md:mb-[90px] md:pt-16 lg:max-w-[615px]">
        <div className="mb-8 flex h-full w-full flex-col gap-4 bg-background md:mt-0 md:gap-8 md:px-6">
          <h3 className="w-full py-2 text-xl font-[650] leading-[120%] sm:text-[32px] md:py-0">
            {t("circle.created")}
          </h3>
          <p className="text-2xl font-normal leading-[114%]">{t("circle.createdDescription")}</p>
          <p className="text-2xl font-normal leading-[114%]">
            {t("circle.sendLink")} <br />
            {t("circle.expand")}
          </p>
          <div className="flex w-full flex-col items-start gap-2">
            <p className="text-sm font-650 text-[#232329]">{t("circle.copyLink")}</p>
            <div
              className={cn(
                "items-center min-h-[53px] flex flex-row justifybetween w-full bg-[#F4F3F2",
              )}
              id="joyride-circle-share-link"
            >
              <p className="flex h-full w-full items-center truncate rounded-l rounded-r-none border-0 bg-[#F4F3F2] p-4 text-sm rtl:rounded-r">
                {shareData.url}
              </p>
              <button
                className="flex h-full items-center rounded-r bg-[#F4F3F2] p-4 hover:bg-[#F8F7F7] rtl:rounded-l"
                onClick={() => {
                  navigator.clipboard.writeText(shareData.url);
                  toast.success(t("circle.linkCopied"), {
                    position: "top-center",
                  });
                }}
                aria-label="Copy Program URL"
              >
                <CopyIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
      <StepFooter onSubmit={() => navigate({ to: "/programs" })} currentStep={currentStep} />
    </>
  );
};
